module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_3_sp_79cd3cd8f86343f864269763daea492a.jpg";